import React, { useState } from 'react';
import { Textarea } from '../ui/Textarea';
import { Button } from '../ui/Button';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  onSendMessage,
  disabled = false,
  placeholder = 'Type your message...',
}) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex shrink-0 items-end gap-2 border-t border-stitch-border bg-stitch-surface p-4"
    >
      <div className="min-w-0 flex-1">
        <Textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          rows={1}
          className="max-h-32 min-h-[40px] resize-none"
          onInput={(e) => {
            const target = e.target as HTMLTextAreaElement;
            target.style.height = '40px';
            target.style.height = `${Math.min(target.scrollHeight, 128)}px`;
          }}
        />
      </div>
      <Button
        type="submit"
        variant="primary"
        size="md"
        disabled={disabled || !message.trim()}
        className="shrink-0 !p-2.5"
        aria-label="Send message"
      >
        <span className="material-symbols-outlined text-xl" style={{ fontVariationSettings: "'wght' 500" }}>
          send
        </span>
      </Button>
    </form>
  );
};
